import DealerInventoryTable from "./dealerInventoryTable.container";

export default DealerInventoryTable;
